import { useContact } from '../../contacts/hooks/useContact';
import { useGenerateRandomName } from './useGenerateRandomName';
import { v4 as uuidv4 } from 'uuid';
import { ContactStatus } from '../../contacts/types';

export const useGenerateContact = () => {
    const { createRecord } = useContact();
    const { generateName } = useGenerateRandomName();

    const generate = async (count: number = 1) => {
        for (let i = 0; i < count; i++) {
            const { givenName, familyName, email } = generateName();
            const contact = {
                id: uuidv4(),
                firstName: givenName,
                lastName: familyName,
                email: email,
                status: ContactStatus.ACTIVE,
            };
            createRecord(contact);
        }
    };

    return { generate };
};
